import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { eventNames } from "process";

@Injectable({
  providedIn: "root",
})
export class AnalyticsLibraryService {
  public dictionary: any = [];

  constructor(private translate: TranslateService) {
    this.setITDictionary();
  }

  getStringAction(s: string, t: boolean) {
    if (t) return this.getTranslation(s);
    else return s;
  }

  getEventTrackerObj(
    a: string,
    b: string,
    q: any,
    v: string = null,
    ta: boolean = false
  ) {
    let action: any = [];
    if (typeof q == "object") {
      var i = 0;
      for (let s of q) {
        action[i] = this.getStringAction(s, ta);
        i++;
      }
    } else if (typeof q == "string") {
      action = this.getStringAction(q.toString(), ta);
    }

    return {
      category: this.getTranslation(a),
      action: action,
      label: this.getTranslation(b),
      value: v,
    };
  }

  protected sendGAECommerceEvent(ecommerce: any) {
    try {
      var dataLayer = ((<any>window).dataLayer = (<any>window).dataLayer || []);
      if (!ecommerce) {
        dataLayer.push({ ecommerce: null });
      } else {
        dataLayer.push({
          event: "purchase",
          ecommerce,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  protected generateTransactionID() {
    const date = new Date();
    const year = date.getFullYear().toString().slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const randomPart = Math.random().toString(36).substring(2, 8);

    return `${year}${month}${day}-${randomPart}`;
  }

  protected getCategory(systemID: number, dictionarySystems: any = []) {
    let systemDescription = "ID not found:" + systemID;
    let system = dictionarySystems.find((s) => s.ID === systemID);
    if (system) {
      systemDescription = this.getTranslation(system.Description + "_B2C");
    }
    return systemDescription;
  }

  sendECommerce(
    listMaterials: any = [],
    dictionarySystems: any = [],
    totalAmount: number = 0
  ) {
    var items = [];
    var transactionID = this.generateTransactionID();

    for (var i = 0; i < listMaterials.length; i++) {
      items.push({
        item_id: listMaterials[i].Code,
        item_name: listMaterials[i].Description,
        item_list_name: transactionID,
        item_brand: "BTI",
        item_category: this.getCategory(
          listMaterials[i].SystemID,
          dictionarySystems
        ),
        item_variant: "",
        index: i,
        quantity: listMaterials[i].Quantity,
        price: parseFloat(listMaterials[i].PriceRR),
        affiliation: "B2C",
      });
    }

    this.sendGAECommerceEvent(null);
    this.sendGAECommerceEvent({
      transaction_id: transactionID,
      value: totalAmount,
      currency: "EUR",
      items: items,
      tax: 0,
      shipping: 0,
    });
  }

  sendPageView(l: string) {
    try {
      if (l === null) {
        console.log("Error sendPageView -> cannot has location === null");
      } else {
        var dataLayer = ((<any>window).dataLayer =
          (<any>window).dataLayer || []);
        var location = window.location.protocol + '//' + window.location.hostname + l.replace("#/", "");
        var fake_ids = l.replace(/\//g, "_");

        var title = "";
        if (fake_ids === "_" || fake_ids === "_home" ) {
          fake_ids = "IDS_TITLE_INTRODUCTION";
          title = this.getTranslation(fake_ids);
        } else if (fake_ids.includes("share_")) {
          var end = fake_ids.indexOf("share_") + 5;
          fake_ids = fake_ids.substring(0, end);
          title = this.getTranslation(fake_ids);
        } else if (fake_ids.includes("open_")) {
          var end = fake_ids.indexOf("open_") + 4;
          fake_ids = fake_ids.substring(0, end);
          title = this.getTranslation(fake_ids);
        } else {
          fake_ids = "IDS_TITLE" + fake_ids;
          var real_ids = this.getTranslation(fake_ids);
          if (real_ids != undefined) {
            title = this.translate.instant(real_ids);
          } else {
            title = l;
          }
        }

        dataLayer.push({
          event: "page_view",
          page_title: title, //"[Nome della pagina]",
          page_location: location, //"[Indirizzo della pagina senza #/]",
          page_path: l, //"[Path della pagina senza dominio]",
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  sendPageViewInfo(t: string) {
    try {
      if (t === null || t === undefined) {
        console.log("Error sendPageView -> cannot has location === null");
      } else {
        var dataLayer = ((<any>window).dataLayer =
          (<any>window).dataLayer || []);
        var t_slug = '/modalpage/' + t.replace(/\//g, "_").replace(/\s/g, "-").toLowerCase();
        var title = t;
        var location = window.location.protocol + '//' + window.location.hostname + t_slug;
        dataLayer.push({
          event: "page_view",
          page_title: title, //"[Titolo della modale]", // es “Smarther2 with Netatmo”
          page_location: location, //"https://preventivatore.bticino.it/modalpage/[Titolo in slug]",
          page_path: t_slug, //"/modalpage/[Titolo in slug]",
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  sendGAEventWithInfo(eventTitle: string, otherInfo: [{ key: string, value: number }] = null) {
    try {
      if (eventTitle === null || eventTitle === undefined) {
        console.log("Error sendGAEventWithInfo -> cannot has eventTitle = null or undefined");
      } else {
        var event = {'event': this.getTranslationOrValue(eventTitle)};
        if (otherInfo!=null){
          otherInfo.forEach(input => {
            event[this.getTranslationOrValue(input.key)] = input.value;
          });
        }
        var dataLayer = (<any>window).dataLayer = (<any>window).dataLayer || [];
        dataLayer.push(event);
      }

    } catch (e) {
      console.log(e);
    }
  }

  sendGAEventWithInfoString(eventTitle: string, otherInfo: [{ key: string, value: string }] = null) {
    try {
      if (eventTitle === null || eventTitle === undefined) {
        console.log("Error sendGAEventWithInfo -> cannot has eventTitle = null or undefined");
      } else {
        var event = {'event': this.getTranslationOrValue(eventTitle)};
        if (otherInfo!=null){
          otherInfo.forEach(input => {
            event[this.getTranslationOrValue(input.key)] = this.getTranslationOrValue(input.value);
          });
        }
        var dataLayer = (<any>window).dataLayer = (<any>window).dataLayer || [];
        dataLayer.push(event);
      }

    } catch (e) {
      console.log(e);
    }
  }

  setITDictionary() {
    this.dictionary["IDS_GTAG_CATEGORY"] = "Casa Smart | Preventivatore";
    this.dictionary["IDS_GTAG_CATEGORY_INFO"] = "Casa Smart | Info laterale";
    this.dictionary["IDS_WHATTODO_LABEL"] = "Step 0 - Cosa vuoi fare?";
    this.dictionary["IDS_HAVINGLL_LABEL"] = "Step 0-1 - Modifica impianto";
    this.dictionary["IDS_ROOMS_LABEL_b2c.IDS_NEW_IMPLANT"] =
      "Step 1 - Quanti locali | Nuovo impianto";
    this.dictionary["IDS_ROOMS_LABEL_b2c.IDS_MOD_IMPLANT"] =
      "Step 1 - Quanti locali | Sostituzione impianto";
    this.dictionary["IDS_ROOMS_LABEL_b2c.IDS_UPD_IMPLANT"] =
      "Step 1 - Quanti locali | Modifica impianto";
    this.dictionary["IDS_SYSTEMS_LABEL_b2c.IDS_NEW_IMPLANT"] =
      "Step 2 - Cosa gestire | Nuovo impianto";
    this.dictionary["IDS_SYSTEMS_LABEL_b2c.IDS_MOD_IMPLANT"] =
      "Step 2 - Cosa gestire | Sostituzione impianto";
    this.dictionary["IDS_SYSTEMS_LABEL_b2c.IDS_UPD_IMPLANT"] =
      "Step 2 - Cosa gestire | Modifica impianto";
    this.dictionary["IDS_FINISHING_LABEL_TECHNOLOGY_2"] =
      "Step 3 - Linea estetica | Casa smart";
    this.dictionary["IDS_FINISHING_LABEL_TECHNOLOGY_3"] =
      "Step 3 - Linea estetica | Casa domotica";
    this.dictionary["IDS_COVERCONFIGURATOR_SHAPE_1_TECHNOLOGY_2"] =
      "Step 4 - Colore | LL Quadra | Casa smart";
    this.dictionary["IDS_COVERCONFIGURATOR_SHAPE_2_TECHNOLOGY_2"] =
      "Step 4 - Colore | LL Air | Casa smart";
    this.dictionary["IDS_COVERCONFIGURATOR_SHAPE_3_TECHNOLOGY_2"] =
      "Step 4 - Colore | LL International | Casa smart";
    this.dictionary["IDS_COVERCONFIGURATOR_SHAPE_1_TECHNOLOGY_3"] =
      "Step 4 - Colore | LL Quadra | Casa domotica";
    this.dictionary["IDS_COVERCONFIGURATOR_SHAPE_2_TECHNOLOGY_3"] =
      "Step 4 - Colore | LL Air | Casa domotica";
    this.dictionary["IDS_COVERCONFIGURATOR_SHAPE_3_TECHNOLOGY_3"] =
      "Step 4 - Colore | LL International | Casa domotica";
    this.dictionary["IDS_COVERCONFIGURATOR_TECHNOLOGY_2_FINISHING2"] =
      "Step 4 - Colore | Matix | Casa smart";
    this.dictionary["IDS_COVERCONFIGURATOR_TECHNOLOGY_3_FINISHING2"] =
      "Step 4 - Colore | Matix | Casa domotica";
    this.dictionary["IDS_COVERCONFIGURATOR_TECHNOLOGY_2_FINISHING4"] =
      "Step 4 - Colore | LN | Casa smart";
    this.dictionary["IDS_COVERCONFIGURATOR_TECHNOLOGY_3_FINISHING4"] =
      "Step 4 - Colore | LN | Casa domotica";
    this.dictionary["IDS_COVERCONFIGURATOR_TECHNOLOGY_2_FINISHING7"] =
      "Step 4 - Colore | LN digitali | Casa smart";
    this.dictionary["IDS_COVERCONFIGURATOR_TECHNOLOGY_3_FINISHING7"] =
      "Step 4 - Colore | LN digitali | Casa domotica";
    this.dictionary["IDS_TIMES_TECHNOLOGY_2_FINISHING2"] =
      "Step 7 - Quando | Matix | Casa smart";
    this.dictionary["IDS_TIMES_TECHNOLOGY_3_FINISHING2"] =
      "Step 7 - Quando | Matix | Casa domotica";
    this.dictionary["IDS_TIMES_TECHNOLOGY_2_FINISHING4"] =
      "Step 7 - Quando | LN | Casa smart";
    this.dictionary["IDS_TIMES_TECHNOLOGY_3_FINISHING4"] =
      "Step 7 - Quando | LN | Casa domotica";
    this.dictionary["IDS_TIMES_TECHNOLOGY_2_FINISHING7"] =
      "Step 7 - Quando | LN digitali | Casa smart";
    this.dictionary["IDS_TIMES_TECHNOLOGY_3_FINISHING7"] =
      "Step 7 - Quando | LN digitali | Casa domotica";
    this.dictionary["IDS_TIMES_SHAPE_1_TECHNOLOGY_2"] =
      "Step 7 - Quando | LL Quadra | Casa smart";
    this.dictionary["IDS_TIMES_SHAPE_2_TECHNOLOGY_2"] =
      "Step 7 - Quando | LL Air | Casa smart";
    this.dictionary["IDS_TIMES_SHAPE_3_TECHNOLOGY_2"] =
      "Step 7 - Quando | LL International | Casa smart";
    this.dictionary["IDS_TIMES_SHAPE_1_TECHNOLOGY_3"] =
      "Step 7 - Quando | LL Quadra | Casa domotica";
    this.dictionary["IDS_TIMES_SHAPE_2_TECHNOLOGY_3"] =
      "Step 7 - Quando | LL Air | Casa domotica";
    this.dictionary["IDS_TIMES_SHAPE_3_TECHNOLOGY_3"] =
      "Step 7 - Quando | LL International | Casa domotica";
    this.dictionary["IDS_QUOTATION_TECHNOLOGY_2_FINISHING2"] =
      "Step 8 - Preventivo | Matix | Casa smart";
    this.dictionary["IDS_QUOTATION_TECHNOLOGY_3_FINISHING2"] =
      "Step 8 - Preventivo | Matix | Casa domotica";
    this.dictionary["IDS_QUOTATION_TECHNOLOGY_2_FINISHING4"] =
      "Step 8 - Preventivo | LN | Casa smart";
    this.dictionary["IDS_QUOTATION_TECHNOLOGY_3_FINISHING4"] =
      "Step 8 - Preventivo | LN | Casa domotica";
    this.dictionary["IDS_QUOTATION_TECHNOLOGY_2_FINISHING7"] =
      "Step 8 - Preventivo | LN digitali | Casa smart";
    this.dictionary["IDS_QUOTATION_TECHNOLOGY_3_FINISHING7"] =
      "Step 8 - Preventivo | LN digitali | Casa domotica";
    this.dictionary["IDS_QUOTATION_SHAPE_1_TECHNOLOGY_2"] =
      "Step 8 - Preventivo | LL Quadra | Casa smart";
    this.dictionary["IDS_QUOTATION_SHAPE_2_TECHNOLOGY_2"] =
      "Step 8 - Preventivo | LL Air | Casa smart";
    this.dictionary["IDS_QUOTATION_SHAPE_3_TECHNOLOGY_2"] =
      "Step 8 - Preventivo | LL International | Casa smart";
    this.dictionary["IDS_QUOTATION_SHAPE_1_TECHNOLOGY_3"] =
      "Step 8 - Preventivo | LL Quadra | Casa domotica";
    this.dictionary["IDS_QUOTATION_SHAPE_2_TECHNOLOGY_3"] =
      "Step 8 - Preventivo | LL Air | Casa domotica";
    this.dictionary["IDS_QUOTATION_SHAPE_3_TECHNOLOGY_3"] =
      "Step 8 - Preventivo | LL International | Casa domotica";
    this.dictionary["b2c.IDS_UPD_IMPLANT"] = "Rendere smart impianto esistente";
    this.dictionary["b2c.IDS_MOD_IMPLANT"] = "Sostituire impianto esistente";
    this.dictionary["b2c.IDS_NEW_IMPLANT"] = "Nuovo impianto";
    this.dictionary["b2c.IDS_YES"] = "Ho Livinglight";
    this.dictionary["b2c.IDS_NO"] = "Non ho Livinglight";
    this.dictionary["b2c.IDS_DONTKNOW"] = "Non lo so";
    this.dictionary["roomType.IDS_ENTRANCE"] = "i";
    this.dictionary["roomType.IDS_KITCHEN"] = "ca";
    this.dictionary["roomType.IDS_LIVINGROOM"] = "s";
    this.dictionary["roomType.IDS_BEDROOM"] = "c";
    this.dictionary["roomType.IDS_BATHROOM"] = "b";
    this.dictionary["roomType.IDS_GENERIC"] = "lg";
    this.dictionary["roomType.IDS_LAUNDRY"] = "la";
    this.dictionary["roomType.IDS_CARBOX"] = "bx";
    this.dictionary["roomType.IDS_BASEMENT"] = "t";
    this.dictionary["roomType.IDS_CEILING"] = "m";
    this.dictionary["roomType.IDS_UTILITYROOM"] = "r";
    this.dictionary["roomType.IDS_LIVINGROOMSKITCHINETTES"] = "ac";
    this.dictionary["system.IDS_COVDESCRIPTION_B2C"] = "Placche";
    this.dictionary["system.IDS_LU1DESCRIPTION_B2C"] = "Luci";
    this.dictionary["system.IDS_LOCDESCRIPTION_B2C"] = "Videocitofono";
    this.dictionary["system.IDS_FTTDESCRIPTION_B2C"] = "Prese";
    this.dictionary["system.IDS_TERDESCRIPTION_B2C"] = "Termostato";
    this.dictionary["system.IDS_TAPDESCRIPTION_B2C"] = "Tapparelle";
    this.dictionary["system.IDS_CAMDESCRIPTIION_B2C"] = "Gestione carichi";
    this.dictionary["system.IDS_ANFDESCRIPTION_B2C"] = "Sicurezza";
    this.dictionary["system.IDS_QDCDESCRIPTION_B2C"] = "Cabinet Quadro";
    this.dictionary["system.IDS_QDPDESCRIPTION_B2C"] = "Protezioni Quadro";
    this.dictionary["system.IDS_VICDESCRIPTION_B2C"] = "Gestione carichi"; //Visualizzazione consumi';
    this.dictionary["system.IDS_SERDESCRIPTION_B2C"] = "Servizi";
    this.dictionary["IDS_344682_B2C"] = "Classe 100X";
    this.dictionary["IDS_344842_B2C"] = "Classe 300EOS";
    this.dictionary["IDS_FINISHING2"] = "Matix";
    this.dictionary["IDS_FINISHING3"] = "LivingLight";
    this.dictionary["IDS_FINISHING4"] = "LivingNow";
    this.dictionary["IDS_FINISHING5"] = "MatixGO";
    this.dictionary["IDS_FINISHING7"] = "LivingNow con comandi digitali";
    this.dictionary["IDS_SWITCH_1"] = " - Bianca";
    this.dictionary["IDS_SWITCH_2"] = " - Tech";
    this.dictionary["IDS_SWITCH_3"] = " - Antracite";
    this.dictionary["IDS_SWITCH_1_NOW"] = " - Bianca";
    this.dictionary["IDS_SWITCH_2_NOW"] = " - Sabbia";
    this.dictionary["IDS_SWITCH_3_NOW"] = " - Nera";
    this.dictionary["b2c.IDS_2MONTHS"] = "Entro 2 mesi";
    this.dictionary["b2c.IDS_4MONTHS"] = "Entro 4 mesi";
    this.dictionary["b2c.IDS_6MONTHS"] = "Entro 6 mesi";
    this.dictionary["b2c.IDS_MOREMONTHS"] = "Oltre 6 mesi";
    this.dictionary["check-livinglight-lateral"] =
      "Info - Serie Installata | LivingLight";
    this.dictionary["livinglight-lateral"] =
      "Info - Scelta serie e tipo | LivingLight";
    this.dictionary["livingnow-lateral"] =
      "Info - Scelta serie e tipo | LivingNow";
    this.dictionary["IDS_INTERNALUNIT_LABEL_b2c.IDS_NEW_IMPLANT"] =
      "Step - Videocitofono | Nuovo impianto";
    this.dictionary["IDS_INTERNALUNIT_LABEL_b2c.IDS_MOD_IMPLANT"] =
      "Step - Videocitofono | Sostituzione impianto";
    this.dictionary["IDS_INTERNALUNIT_LABEL_b2c.IDS_UPD_IMPLANT"] =
      "Step - Videocitofono | Modifica impianto";
    this.dictionary["IDS_SMARTCAMERA_LABEL_b2c.IDS_NEW_IMPLANT"] =
      "Step - Smartcamera | Nuovo impianto";
    this.dictionary["IDS_SMARTCAMERA_LABEL_b2c.IDS_MOD_IMPLANT"] =
      "Step - Smartcamera | Sostituzione impianto";
    this.dictionary["IDS_SMARTCAMERA_LABEL_b2c.IDS_UPD_IMPLANT"] =
      "Step - Smartcamera | Modifica impianto";
    this.dictionary["true"] = "Si";
    this.dictionary["false"] = "No";
    this.dictionary["IDS_SUMMARY_FORM_DISPLAYED"] = "form_displayed";
    this.dictionary["IDS_SUMMARY_FORM_FILLING"] = "form_filling";
    this.dictionary["IDS_SUMMARY_FORM_INVALID"] = "form_invalid";
    this.dictionary["IDS_SUMMARY_FORM_SUBMIT"] = "form_submit";
    this.dictionary["IDS_SUMMARY_FORM_SUCCESS"] = "form_success";
    this.dictionary["IDS_SUMMARY_FORM_ERROR"] = "form_error";

    this.dictionary["IDS_TITLE_INTRODUCTION"] =
      "Preventiva la tua casa smart con BTicino"; //quando viene chiamato la prima volta la traduzione non è ancora caricata quindi devo lasciaro qui;
    this.dictionary["IDS_TITLE_share"] =
      "Contatta un professionista della Smart Home.";
    this.dictionary["IDS_TITLE_open"] = "Modifica il tuo preventivo";
    this.dictionary["IDS_TITLE_wiz_whattodo"] = "b2c.IDS_WHATTODO_QUE";
    this.dictionary["IDS_TITLE_wiz_havingbticino"] = "b2c.IDS_HAVINGLL_QUE";
    this.dictionary["IDS_TITLE_wiz_rooms"] = "b2c.IDS_ROOMS_QUE";
    this.dictionary["IDS_TITLE_wiz_systems"] = "b2c.IDS_SYSTEMS_QUE";
    this.dictionary["IDS_TITLE_wiz_internalunit"] = "b2c.IDS_INTERNALUNIT_QUE";
    this.dictionary["IDS_TITLE_wiz_softsecurity"] = "b2c.IDS_SMARTCAMERA_QUE";
    this.dictionary["IDS_TITLE_wiz_smartthermo"] = "b2c.IDS_SMARTTHERMO_QUE";
    this.dictionary["IDS_TITLE_wiz_finishing"] = "b2c.IDS_FINISHING_QUE";
    this.dictionary["IDS_TITLE_wiz_frameshape"] = "b2c.IDS_FRAMESHAPE_QUE";
    this.dictionary["IDS_TITLE_wiz_coverconfigurator"] =
      "b2c.IDS_COVERCONFIGURATOR_QUE";
    this.dictionary["IDS_TITLE_wiz_times"] = "b2c.IDS_TIMES_QUE";
    this.dictionary["IDS_TITLE_wiz_summary"] = "b2c.IDS_SUMMARY_QUE";
    this.dictionary["IDS_TITLE_wiz_thanks"] = "b2c.IDS_THANKS_QUE";


    this.dictionary["STEP_0_b2c.IDS_NEW_IMPLANT"] = "step0_value_nuovo";
    this.dictionary["STEP_0_b2c.IDS_MOD_IMPLANT"] = "step0_value_sostituire";
    this.dictionary["STEP_0_b2c.IDS_UPD_IMPLANT"] = "step0_value_parziale";

    this.dictionary["STEP_0SERIE_b2c.IDS_DONTKNOW"] = "step0serie_value_dontknow";
    this.dictionary["STEP_0SERIE_finishing.IDS_LIVINGLIGHT"] = "step0serie_value_livinglight";
    this.dictionary["STEP_0SERIE_finishing.IDS_LIVINGNOW"] = "step0serie_value_livingnow";
    this.dictionary["STEP_0SERIE_finishing.IDS_MATIXGO"] = "step0serie_value_matixgo";
    this.dictionary["STEP_0SERIE_finishing.IDS_MATIX"] = "step0serie_value_matix";

    this.dictionary["STEP_1_roomType.IDS_BASEMENT"] = "step1_value_taverna"
    this.dictionary["STEP_1_roomType.IDS_BATHROOM"] = "step1_value_bagno"
    this.dictionary["STEP_1_roomType.IDS_BEDROOM"] = "step1_value_camera"
    this.dictionary["STEP_1_roomType.IDS_CARBOX"] = "step1_value_box"
    this.dictionary["STEP_1_roomType.IDS_CEILING"] = "step1_value_mansarda"
    this.dictionary["STEP_1_roomType.IDS_ENTRANCE"] = "step1_value_ingresso"
    this.dictionary["STEP_1_roomType.IDS_GENERIC"] = "step1_value_generico"
    this.dictionary["STEP_1_roomType.IDS_KITCHEN"] = "step1_value_cucina"
    this.dictionary["STEP_1_roomType.IDS_LAUNDRY"] = "step1_value_lavanderia"
    this.dictionary["STEP_1_roomType.IDS_LIVINGROOM"] = "step1_value_soggiorno"
    this.dictionary["STEP_1_roomType.IDS_LIVINGROOMSKITCHINETTES"] = "step1_value_angolocottura"
    this.dictionary["STEP_1_roomType.IDS_UTILITYROOM"] = "step1_value_ripostiglio"

    this.dictionary["STEP_2_IDS_ANF"]= "step_2_value_sicurezza";
    this.dictionary["STEP_2_IDS_CAM"]= "step2_value_gestionecarichi";
    this.dictionary["STEP_2_IDS_LOC"]= "step2_value_videocitofono";
    this.dictionary["STEP_2_IDS_LU1"]= "step_2_value_luci";
    this.dictionary["STEP_2_IDS_TAP"]= "step_2_value_tapparelle";
    this.dictionary["STEP_2_IDS_TER"]= "step2_value_termostato";
    this.dictionary["STEP_2_IDS_VIC"]= "step2_value_preseconnesse";

    this.dictionary["STEP_2_INFO"] = "step_2_info";
    this.dictionary["STEP_2_INFO_TITLE"] = "step_2_info_title";

    this.dictionary["STEP_3_finishing.IDS_LIVINGLIGHT"] = "step3_value_livinglight";
    this.dictionary["STEP_3_finishing.IDS_LIVINGNOW"] = "step3_value_livingnow";
    this.dictionary["STEP_3_finishing.IDS_MATIXGO"] = "step3_value_matixgo";
    this.dictionary["STEP_3_finishing.IDS_MATIX"] = "step3_value_matix";

    this.dictionary["STEP_4_b2c.IDS_2MONTHS"] = "step4_value_2mesi";
    this.dictionary["STEP_4_b2c.IDS_4MONTHS"] = "step4_value_4mesi";
    this.dictionary["STEP_4_b2c.IDS_6MONTHS"] = "step4_value_6mesi";
    this.dictionary["STEP_4_b2c.IDS_MOREMONTHS"] = "step4_value_other";
  }

  getTranslation(ids: string) {
    return this.dictionary[ids];
  }
  getTranslationOrValue(ids: string) {
    let traduzione = this.dictionary[ids];
    if (traduzione === undefined)
      traduzione = ids;
    return traduzione;
  }
}
